import { DatePipe, CommonModule, TitleCasePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { Router, RouterModule } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from "rxjs";
import { NetworkComponent } from "src/app/page/homepage/network/network.component";
import { TeamComponent } from 'src/app/page/homepage/team/team.component';
import { AppSettings } from "src/app/services/AppSettings";
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { ApiService } from 'src/app/services/api.service';
import { GigsumoService } from 'src/app/services/gigsumoService';
import { JobService } from 'src/app/services/job.service';
import { SearchData } from "src/app/services/searchData";
import { UtilService } from 'src/app/services/util.service';
import { ConfettiService } from 'src/app/shared/celabaration/confetti.service';
import Swal from "sweetalert2";
import { PricePlanService } from '../Price-subscritions/priceplanService';
import { CurrentOrganizationProviderService } from '../../services/current-organization-provider.service';
import { CustomerService } from './../bussinesspages/user-management/customer-service.service';
import { ContractService } from '../../services/contract.service';
import { B2bDocumentSetupComponent } from '../shared/b2b-document-setup/b2b-document-setup.component';
import { WidgetModule } from '../../widget/widget.module';
import { NotificationConfigComponent } from '../notification-config/notification-config.component';
import { CommonModalComponent } from '../bussinesspages/user-management/common-modal/common-modal.component';
import { TruncatePipe } from '../../pipe/TruncatePipe.pipe';
import { CommonSkeletonComponent } from '../../skeleton/common-skeleton/common-skeleton.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { DecodeUriPipe } from '../../pipe/decode-uri.pipe';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';
import { NotificationMessageComponent, NotificationMessageAction } from '../../shared/ui/notification-message/notification-message.component';
import { prepareNotificationForDisplay } from '../../shared/ui/notification-message/notification-prepare';


export enum MESSAGESTATUS {
  EMPTY, MESSAGE
}
@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [CommonModule,
    RouterModule,
    WidgetModule,
    NotificationConfigComponent,
    CommonModalComponent,
    TruncatePipe,
    CommonSkeletonComponent,
InfiniteScrollModule,
    TitleCasePipe,
    MatMenuModule,
    DecodeUriPipe,
    NG_ICON_DIRECTIVES,
    NotificationMessageComponent,
  ],
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  providers: [DatePipe]
})

export class NotificationComponent implements OnInit, OnDestroy {
  notificationStatus: "Fetching Notifications..."
  notifications: any = [];
  bottomFlag: boolean = false
  userId = localStorage.getItem('userId');
  unreadUserMsgCount: number = 0;
  notificationcount: number = 0;
  clickEventsubscription: Subscription;
  url = AppSettings.photoUrl;
  countEmitter: Subscription;
  notificationReadSub: Subscription;
  notificationsRefreshSub: Subscription;
  isEnabled: boolean = false;
  public innerHeight;
  public chatHeight;
  GigsumoConstant = GigsumoConstants;
  eventEmitterData: Subscription;
  prevAfterkey=null;
  supportedNotifyTypes = [
    'MONTHLY_ADD_ON_CREDITS',
    'MONTHLY_REFRESH_ALERT',
    'CREDIT_COSNUMED_FOR_JOBS',
    'CREDIT_REWARDED',
    'BUSINESS_PAGE_BLOCKED',
    'BUSINESS_PAGE_UNBLOCKED',
    'STRIPE_INVOICE_SUCCESS',
    'STRIPE_INVOICE_FAILURE',
    'CREDIT_COSNUMED_FOR_CANDIDATES',
    'JOBS_DOWNGRADED',
    'CANDIDATES_DOWNGRADED',
    'JOBS_DOWNGRADING_ALERT',
    'CANDIDATES_DOWNGRADING_ALERT',
    'ADMIN_ACTION_ON_REPORT',
    'FLAG_RECEIVED_ACKNOWLEDGEMENT',
    'MEMBERSHIP_UPDATED',
    'STRIPE_PAYMENT_TRANSACTION_FAILURE',
    'SUGGESTED_CANDIDATES_TO_JOB_OWNER',
    'SUGGESTED_JOBS_TO_CANDIDATE_OWNER',
    'JOB_APPLIED_TO_JOB_OWNER',
    'JOB_APPLIED_TO_CANDIDATE_OWNER',
    'SUGGESTED_CANDIDATE_REFRESH',
    'SUGGESTED_JOB_REFRESH',
    'CONTRACT_AGREEMENT_DOCUMENT_UPLOADED',
    'CONTRACT_COMPANY_DOC_CHECKLIST_CREATED',
    'CONTRACT_COMPANY_DOC_UPLOADED',
    'CONTRACT_COMPANY_DOC_VERIFIED',
    'CONTRACT_COMPANY_DOC_REJECTED',
    'CONTRACT_AGREEMENT_SIGNING_REQUESTED',
    'CONTRACT_AGREEMENT_SIGNED',
    'CONTRACT_AGREEMENT_ACCEPTED',
    'CONTRACT_AGREEMENT_REJECTED',
    'CONTRACT_WORK_ORDER_INITIATED',
    'CONTRACT_WORK_ORDER_ACCEPTED',
    'CONTRACT_WORK_ORDER_REJECTED',
    'CONTRACT_WORK_ORDER_REVISED',
    'CONTRACT_WORK_ORDER_VOIDED',
    'CONTRACT_INITIATED',
    'CONTRACT_INVOICE_SUBMITTED',
    'CONTRACT_INVOICE_UPDATED',
    'CONTRACT_INVOICE_APPROVED',
    'CONTRACT_INVOICE_REJECTED',
    'CONTRACT_INVOICE_PAID',
    'CONTRACT_PAYMENT_RECEIVED',
    'CONTRACT_INVOICE_VOIDED'
  ];

  notificationSettings:boolean  = false;
  userType :any;

  constructor(private api: ApiService, private util: UtilService, private pricePlanService : PricePlanService,private customerService : CustomerService,
    private router: Router, private searchData: SearchData, private Gigsumoservice:GigsumoService,private confettiService: ConfettiService,
    private netCls: NetworkComponent,private cdr: ChangeDetectorRef,private modalService: BsModalService,
    private tmCls: TeamComponent, private JobServicecolor: JobService, private currentOrgProvider: CurrentOrganizationProviderService,
    private contractService: ContractService
  ) {
    this.userId = localStorage.getItem('userId');
    this.userType = localStorage.getItem('userType');
    this.getUserHeaderCount();
    this.eventEmitterData = this.searchData.getCommonVariables().subscribe(res => {
      if (res.offSetMap && res.notifications) {
        this.commonVariables.notifications = res.notifications
      }
    });
    this.countEmitter = this.searchData.getNotificationCount().subscribe(res => {
      if (res)
        this.unreadUserMsgCount = res.unreadUserMsgCount;
      this.notificationcount = res.notificationcount;
    })
    // The bell-icon flyout marks notifications read via its own API call
    // against its own fetched list; pick up its broadcast so this page's
    // row flips to read/white too, instead of staying stuck until reload.
    this.notificationReadSub = this.searchData.getNotificationRead().subscribe(notifyId => {
      const item = this.commonVariables.notifications?.find((n: any) => n.notifyId === notifyId);
      if (item) {
        item.read = true;
      }
    });
    // Toaster click while already on this page can't rely on router.navigate
    // (same-URL navigation is a no-op), so it broadcasts here instead.
    this.notificationsRefreshSub = this.searchData.getNotificationsRefresh().subscribe(() => {
      this.reloadNotifications();
    });
  }


  isSupportedNotifyType(type: string): boolean {
    return this.supportedNotifyTypes.includes(type);
  }
  getInitials(firstname: string, lastname: string): string {
    return this.JobServicecolor.getInitialsparam(firstname, lastname);
  }

  getColor(firstname: string, lastname: string): string {
    return this.JobServicecolor.getColorparam(firstname, lastname);
  }
  getTextColor(firstname: string, lastname: string): string {
    return this.JobServicecolor.getTextColor(firstname, lastname);
  }
  datechange(date) {
    const dateSendingToServer = new DatePipe('en-US').transform(date, 'MM/dd/yyyy HH:mm');
    return dateSendingToServer;
  }
  extractWorkOrderId(message: string): string {
    if (!message) return '';
    const match = message.match(/WOID\d+/);
    return match ? match[0] : '';
  }
  formatUserType(userType: string): string {
    return userType
      .replace(/_/g, ' ')
      .toLowerCase()
      .replace(/\b\w/g, char => char.toUpperCase());
  }
  getUserHeaderCount() {
    const userId = localStorage.getItem("userId");
    const formattedDate = this.Gigsumoservice.getFormattedCurrentDate()
    this.api.query("user/header/" + userId + "/" + formattedDate).subscribe((res) => {
      if (res) {
        this.unreadUserMsgCount = res.message;
        this.notificationcount = res.notification;
        var commonVariable: any = {}
        commonVariable.unreadUserMsgCount = res.message
        commonVariable.notificationcount = res.notification
        this.searchData.setNotificationCount(commonVariable)
      }
    }, err => {

    });
  }
  ngOnInit() {
    window.scrollTo({top:0, behavior: 'smooth'});
    // On a full reload the nav bar's apicallforDowngrade (findUserPlanBenefits)
    // starts the global spinner; this page has its own "Fetching Notifications..."
    // state, so hide the global one instead of showing both. Deferred so it runs
    // after the nav bar's ngOnInit regardless of which initialises first.
    setTimeout(() => this.util.stopLoader());
    this.getNotificationView()
    this.cdr.detectChanges();
  }


  // Notification over
  /** Inline Accept / Pay buttons rendered by <app-notification-message>. */
  onMessageAction(name: NotificationMessageAction, item: any, i: number) {
    switch (name) {
      case 'acceptCommunityInvitation': return this.acceptCommunityInvitation(item, i);
      case 'scalexPayment': return this.scalexPayment(item, i);
      case 'addOrRejectMemberToCommunity': return this.addOrRejectMemberToCommunity(item, 'ACCEPT', i);
      case 'acceptConnection': return this.acceptConnection(item, i);
      case 'acceptNetworkMemberInvitation': return this.acceptNetworkMemberInvitation(item, i);
      case 'acceptTeamInvitation': return this.acceptTeamInvitation(item, i);
      case 'acceptBusinessEmployee': return this.acceptBusinessEmployee(item, i);
      case 'acceptBusinessFollowerRequest': return this.acceptBusinessFollowerRequest(item, i);
      case 'opencontactmodal': return this.opencontactmodal(item, i);
    }
  }

  celebrate(){
    this.confettiService.launchConfetti();
  }


  ngOnDestroy() {
    if (this.eventEmitterData) {
      this.eventEmitterData.unsubscribe();
    }
    if (this.countEmitter) {
      this.countEmitter.unsubscribe();
    }
    if (this.notificationReadSub) {
      this.notificationReadSub.unsubscribe();
    }
    if (this.notificationsRefreshSub) {
      this.notificationsRefreshSub.unsubscribe();
    }
    if (this.eventEmitterData) {
      this.eventEmitterData.unsubscribe();
    }
  }

  @ViewChild('stickedThere') menuElement: ElementRef;
  @ViewChild('itIsThere') menuElement1: ElementRef;
  stickThere: boolean = false
  beThere: boolean = false

  cumulativeLimit: number = 0

  count: number = 0
  funtioncallFlag: boolean = false

  responseReceived: boolean = false


  commonVariables: any = {};
  isSuperAdmin: boolean = false;

  /** Re-fetch from the first page so a newly arrived notification shows up. */
  private reloadNotifications(): void {
    this.count = 0;
    this.notifications = [];
    this.prevAfterkey = null;
    this.bottomFlag = false;
    this.params.searchAfterKey = null;
    this.getNotificationView();
  }

  getNotificationView(): void {
    this.isEnabled = true;
    this.api.create("notification/find", this.params).subscribe((res) => {
      this.isEnabled = false;
      if (res.status === 500) {
        return;
      }
      if (res.code === "00000" && res.data) {
        this.processNotifications(res.data);
        this.isSuperAdmin = res.data.isSuperAdmin;
      } else if (res.code === "00000" && !res.data) {
        this.handleNoData();
      } else {
        this.funtioncallFlag = false;
      }
    });
  }
    params = {
      userId: this.userId,
      limit: 10,
      searchAfterKey: null,
    };

  private processNotifications(data: any): void {
    this.responseReceived = true;
    this.funtioncallFlag = false;
    if (data.notifications) {
      this.getNotification(data.notifications);
      const afterKey = data.searchAfterKey;
      if (afterKey && JSON.stringify(this.prevAfterkey) !== JSON.stringify(afterKey)) {
        this.prevAfterkey = afterKey;
        this.bottomFlag = false;
      } else if (data.notifications.length === 0) {
        this.bottomFlag = true;
      }
      this.searchData.setCommonVariables(this.commonVariables);
    }
  }

  private handleNoData(): void {
    this.responseReceived = true;
  }

  routeToPageOrProfile(value, category) {
    if (category == 'profile') {
      this.router.navigate(["/personalProfile"], {
        queryParams: { userId: value.notifyData.userId ? value.notifyData.userId : value.notifyEntityId },
      });
    } else if (category == 'businessPage') {
      localStorage.setItem("businessId", value["message"]);
      value["notifyData"].isSuperAdmin = false;
      this.businessDatailsAPI(value["notifyData"], "post")

    } else if (category == 'messageGroup') {
      this.router.navigate(["/message"], {
        queryParams: value["notifyData"],
      });
    } else if (category == 'communityPage') {
      localStorage.setItem("communityId", value["notifyEntityId"]);
      this.router.navigate(["/community"], {
        queryParams: value["notifyData"],
      });
    } else if (category == 'networkPage') {
      localStorage.setItem("networkId", value["notifyEntityId"]);
      this.router.navigate(["/network"], {
        queryParams: value["notifyData"],
      });
    }
  }
  onScrollDown() {

      if (this.prevAfterkey!==undefined&&JSON.stringify(this.params.searchAfterKey) !== JSON.stringify(this.prevAfterkey)) {
        this.params.searchAfterKey = (this.prevAfterkey && this.prevAfterkey.length === 0) ? null : this.prevAfterkey;
        this.getNotificationView();
      }
    const windowScroll = window.pageYOffset;
    if (windowScroll >= 42) {
      this.stickThere = true;
      this.beThere = true;
    } else {
      this.stickThere = false;
      this.beThere = false;
    }
  }
  deleteFromNotification(index) {
    this.commonVariables.notifications.splice(index, 1)
    this.searchData.setCommonVariables(this.commonVariables)
    this.getUserHeaderCount()

  }
  notificationRead(notificationId, index) {
    this.util.startLoader();
    this.api.create("notification/read/" + notificationId, {}).subscribe((res) => {
      if (res && res.code === "00000") {
        this.util.stopLoader();
        // `index` is null for every "View" click (redirectToSaidPage doesn't
        // know its position in the list), so fall back to finding the item
        // by id — otherwise the row never flips to read/white until reload.
        const item = (index != null && index >= 0 && index < this.commonVariables.notifications.length)
          ? this.commonVariables.notifications[index]
          : this.commonVariables.notifications.find(n => n.notifyId === notificationId);
        if (item) {
          item.read = true;
          this.searchData.setCommonVariables(this.commonVariables)
          this.getUserHeaderCount();
        }
        // Tell the bell-icon flyout too — it fetches its own independent
        // list, so without this it would stay purple until reopened.
        this.searchData.markNotificationRead(notificationId);
      } else {
        this.util.stopLoader();
      }
    });
  }
  resendEmployeeRequest(item, index) {
    this.funtioncallFlag = true
    this.util.startLoader();
    var data: any = {}
    data.userId = item['notifyData']['userId']
    data.businessId = item['notifyData']['businessId']
    this.api.create("business/employee/request/send", data).subscribe(res => {
      if (res.code == "00000") {
        this.util.stopLoader();
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Employee request sent successfully",
          showConfirmButton: false,
          timer: 2000,
        }).then((result) => {
          this.deleteFromNotification(index)
          // this.commonvalues.businessid(this.values);
          // this.ngOnInit();
          // this.getnotificationView()
        });
      } else {
        this.util.stopLoader();
        Swal.fire({
          position: "center",
          icon: "info",
          title: "Oops...",
          text: "Sorry, something went wrong. Please try after some time.",
          showConfirmButton: false,
          timer: 5000,
        }).then((result) => {
          // this.commonvalues.businessid(this.values);
          // this.ngOnInit();
        });
      }
    })
  }
  joinRequestNetwork(value, index) {
    this.funtioncallFlag = true
    this.notificationRead(value["notifyId"], index)
    let datas: any = {};
    datas.memberUserId = localStorage.getItem("userId");
    // datas.networkId =   networkId;
    this.util.startLoader()
    this.api.create("network/member/save", datas).subscribe((res) => {
      if (res.code == '00000') {
        // this.getnotificationView()
        this.ngOnInit()
        this.util.stopLoader()
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Nework join request sent",
          showConfirmButton: false,
          timer: 2000,
        })
      } else {
        this.util.stopLoader()
        Swal.fire({
          position: "center",
          icon: "info",
          title: "Oops...",
          text: "Sorry, something went wrong. Please try after some time.",
          showConfirmButton: false,
          timer: 5000,
        })
      }
    });
  }
  acceptBusinessEmployee(value, index) {
    this.util.startLoader();
    this.funtioncallFlag = true;
    let data: any = {};
    data.businessId = value.notifyData.businessId;
    data.userId = value.notifyData.userId;
    this.api
      .create("business/employee/request/accept", data)
      .subscribe((res) => {
        if (res.code == "00000") {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Employee added successfully",
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            this.deleteFromNotification(index)
          })
        } else {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Oops..",
            text: "Something went wrong. Please try again later.",
            showConfirmButton: false,
            timer: 3000,
          });
        }
        this.util.stopLoader();
      });
  }
  rejectBusinessEmployee(value, index) {
    this.funtioncallFlag = true
    let data: any = {};
    data.businessId = value.notifyData.businessId;
    data.userId = value.notifyData.userId;
    this.util.startLoader()
    this.api
      .create("business/employee/request/reject", data)
      .subscribe((res) => {
        if (res.code == "00000") {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Add employee request Denied",
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            this.deleteFromNotification(index)
          })
          this.util.stopLoader()
        } else {
          this.util.stopLoader()
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Oops..",
            text: "Something went wrong. Please try again later.",
            showConfirmButton: false,
            timer: 3000,
          });
        }
      });
  }
  acceptBusinessFollowerRequest(value, index) {
    this.funtioncallFlag = true
    // this.notificationRead(value["notifyId"], index)
    let data: any = {}
    data.businessId = value.notifyData.businessId
    data.userId = localStorage.getItem('userId')
    this.util.startLoader()
    this.api.create('business/follow/accept/request', data).subscribe(res => {
      if (res.code == '00000') {
        // this.getnotificationView()
        // this.admindata.isFollowerInvited=false;
        this.util.stopLoader()
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Follower Added',
          text: 'You are now following the Business Page.',
          showConfirmButton: false,
          timer: 3000
        }).then(() => {
          this.deleteFromNotification(index)
        })
      } else {
        this.util.stopLoader()
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Oops..',
          text: 'Something went wrong. Please try later.',
          showConfirmButton: false,
          timer: 3000
        })
      }
    })
  }
  rejectBusinessFollowerRequest(value, index) {
    this.funtioncallFlag = true
    // this.notificationRead(value["notifyId"], index)
    let data: any = {}
    data.businessId = value.notifyData.businessId
    data.userId = localStorage.getItem('userId')
    this.util.startLoader()
    this.api.create('business/follow/reject/request', data).subscribe(res => {
      if (res.code == '00000') {
        // this.getnotificationView()
        this.util.stopLoader()
        // this.admindata.isFollowerInvited=false;
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Follower request rejected',
          showConfirmButton: false,
          timer: 4000
        }).then(() => {
          this.deleteFromNotification(index)
        })
      } else {
        this.util.stopLoader()
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Oops..',
          text: 'Something went wrong. Please try later.',
          showConfirmButton: false,
          timer: 3000
        })
      }
    })
  }
  redirectToSaidPage(item) {

    console.log("sdsds" , item);

    this.funtioncallFlag = true
    item["redirectFrom"] = "notification";
    if (item["notifyType"] == "CANDIDATE_GOT_SELECTED") {
      this.notificationRead(item["notifyId"], null)
      this.router.navigate(["newcandidates/jobsApplied"], {
        queryParams: item["notifyData"]['candidateData'],
      });
    } else if (item["notifyType"] == "INTERVIEW_SCHEDULED") {
      this.notificationRead(item["notifyId"], null)
      this.router.navigate(["newcandidates/jobsApplied"], {
        queryParams: item["notifyData"]['candidateData'],
      });
    }
    else if (item["notifyType"] == "CANDIDATE_REJECTED") {
      this.notificationRead(item["notifyId"], null)
      this.router.navigate(["newcandidates/jobsApplied"], {
        queryParams: item["notifyData"]['candidateData'],
      });
    }
    else if (item["notifyType"] == "CANDIDATE_SHORTLISTED") {
      this.notificationRead(item["notifyId"], null)
      this.router.navigate(["newcandidates/jobsApplied"], {
        queryParams: item["notifyData"]['candidateData'],
      });
    }
    else if (item["notifyType"] == "JOB_OFFERED") {
      this.notificationRead(item["notifyId"], null)
      this.router.navigate(["newcandidates/jobsApplied"], {
        queryParams: item["notifyData"]['candidateData'],
      });
    }
    else if (item["notifyType"] == "OFFER WITHDRAWN") {
      this.notificationRead(item["notifyId"], null)
      this.router.navigate(["newcandidates/jobsApplied"], {
        queryParams: item["notifyData"]['candidateData'],
      });
    }
    else if (item["notifyType"] == "CANDIDATE BACKOUT") {
      this.notificationRead(item["notifyId"], null)
      this.router.navigate(["newcandidates/jobsApplied"], {
        queryParams: item["notifyData"]['candidateData'],
      });
    }
    else if (item["notifyType"] == "CANDIDATE_PREONBOARDED") {
      this.notificationRead(item["notifyId"], null)
      this.router.navigate(["newcandidates/jobsApplied"], {
        queryParams: item["notifyData"]['candidateData'],
      });
    }
    else if (item["notifyType"] == "CANDIDATE_ONBOARDED") {
      this.notificationRead(item["notifyId"], null)
      this.router.navigate(["newcandidates/jobsApplied"], {
        queryParams: item["notifyData"]['candidateData'],
      });
    }
    else if (item["notifyType"] == "CANDIDATE_INVITATION_ACCEPTED") {
      this.notificationRead(item["notifyId"], null)
      var data: any = {}
      data.jobPostedBy = item["userId"]
      data.jobId = item["notifyData"]['jobId']
      data.points = 0
      data.consumptionType = 'CONSUMPTION_FOR_JOB_VIEW'
      this.router.navigate(["newjobs/candidates-invited"], {
        queryParams: data
      });
    }
    else if (item["notifyType"] == "CANDIDATE_INVITATION_REJECTED") {
      this.notificationRead(item["notifyId"], null)
      var data: any = {}
      data.jobPostedBy = item["userId"]
      data.jobId = item["notifyData"]['jobId']
      data.points = 0
      data.consumptionType = 'CONSUMPTION_FOR_JOB_VIEW'
      this.router.navigate(["newjobs/candidates-invited"], {
        queryParams: data
      });
    }
    else if (item["notifyType"] === "NETWORK_CONNECT_REQUEST_ACCEPTED") {  // going to 404 page
      item.notifyData.networkOwnerId = localStorage.getItem('userId')
      this.notificationRead(item["notifyId"], null)
      this.router.navigate(["networkPage/members"], {
        queryParams: item["notifyData"],
      });
    } else if (item["notifyType"] === "CONNECT_REQUEST_RECEIVED") {
      this.notificationRead(item["notifyId"], null)
      this.router.navigate(["/personalProfile"], {
        queryParams: { userId: item["notifyEntityId"] },
      });
    } else if (item["notifyType"] === "POST_LIKED") {
      this.notificationRead(item["notifyId"], null)
      // this.router.navigate(["/personalProfile"], {
      //   queryParams: { userId: item["notifyEntityId"] },
      // });
    } else if (item["notifyType"] === "POST_COMMENTED") {
      this.notificationRead(item["notifyId"], null)
      // this.router.navigate(["/personalProfile"], {
      //   queryParams: { userId: item["notifyEntityId"] },
      // });
    }
    else if (item["notifyType"] === "POST_SHARED") {
      this.notificationRead(item["notifyId"], null)
      // this.router.navigate(["/personalProfile"], {
      //   queryParams: { userId: item["notifyEntityId"] },
      // });
    }
    else if (item["notifyType"] === "COMMUNITY_USER_INVITE_REQUEST") {
      this.notificationRead(item["notifyId"], null)
      localStorage.setItem("communityId", item["notifyEntityId"]);
      this.router.navigate(["/community"], {
        queryParams: item["notifyData"],
      });
    }
    else if (item["notifyType"] === "COMMUNITY_USER_JOIN_REQUEST") {
      this.notificationRead(item["notifyId"], null)
      item.notifyData.menu = "request"
      localStorage.setItem('communityId', item.notifyData.communityId)
      localStorage.setItem('isAdmin', 'false')
      localStorage.setItem('isSuperAdmin', 'true')
      localStorage.setItem('screen', 'community')
      localStorage.setItem('adminviewflag', 'false')
      localStorage.setItem("communityId", item["notifyEntityId"]);
      this.router.navigate(["/community"], {
        queryParams: item["notifyData"],
      });
    }
    else if (item["notifyType"] === "JOINED_TEAM") {
      this.notificationRead(item["notifyId"], null)
      const temp = item["notifyData"];
      temp.routeFrom = "notification";
      this.router.navigate(["landingPage/team"], {
        queryParams: temp,
      });
    } else if (item["notifyType"] === "JOINED_NETWORK" || item["notifyType"] === "NETWORK_INVITE_SENT") {
      this.notificationRead(item["notifyId"], null)
      const temp = item["notifyData"];
      temp.routeFrom = "notification";
      this.router.navigate(["landingPage/network"], {
        queryParams: temp,
      });
    } else if (
      item["notifyType"] === "BUSINESS_PAGE_FOLLOWER_INVITE_SENT"
    ) {
      this.notificationRead(item["notifyId"], null)
      // //console.log("passing thru this");
      item["notifyData"].isSuperAdmin = false;
      localStorage.setItem("businessId", item["notifyEntityId"]);

      this.businessDatailsAPI(item["notifyData"], 'post')

    } else if (item["notifyType"] === "BUSINESS_EMPLOYEE_REQUEST_REJECTED") {
      this.notificationRead(item["notifyId"], null)
      item["notifyData"].isSuperAdmin = false;
      localStorage.setItem("businessId", item["notifyEntityId"]);
      this.businessDatailsAPI(item["notifyData"], "employee")

    } else if (item["notifyType"] === "BUSINESS_EMPLOYEE_REQUEST_ACCEPTED") {
      this.notificationRead(item["notifyId"], null)
      item["notifyData"].isSuperAdmin = false;
      localStorage.setItem("businessId", item["notifyEntityId"]);
      this.businessDatailsAPI(item["notifyData"], "employee")

    }
    else if (
      item["notifyType"] === "BUSINESS_EMPLOYEE_INVITE_REQUEST"
    ) {
      this.notificationRead(item["notifyId"], null)
      item.notifyData.menu = "requestsReceived"
      item["notifyData"].isSuperAdmin = false;
      localStorage.setItem("businessId", item["message"]);
      this.businessDatailsAPI(item["notifyData"], "employee-requests")

    } else if (
      item["notifyType"] === "BUSINESS_EMPLOYEE_INVITE_SENT"
    ) {
      this.notificationRead(item["notifyId"], null)
      item["notifyData"].isSuperAdmin = false;
      localStorage.setItem("businessId", item["notifyEntityId"]);
      this.businessDatailsAPI(item["notifyData"], "employee")

    } else if (item["notifyType"] === "COMMUNITY_USER_JOINED") {
      this.notificationRead(item["notifyId"], null)
      item.notifyData.menu = "memberspage"
      localStorage.setItem("communityId", item["message"]);
      this.JoinCommunity(item["message"])

    } else if (item["notifyType"] === "COMMUNITY_MEMBER_INVITE_REQUEST") {
      this.notificationRead(item["notifyId"], null)
      item.notifyData.menu = "memberspage"
      localStorage.setItem("communityId", item["notifyEntityId"]);
      this.router.navigate(["/community"], {
        queryParams: item["notifyData"],
      });
    }
    else if (item["notifyType"] === "NETWORK_INVITE_CANCELLED") {
      this.notificationRead(item["notifyId"], null)
      this.router.navigate(["networkPage/home"], {
        queryParams: item["notifyData"],
      });
    } else if (item["notifyType"] === "CONNECTION_REMOVED") {
      this.notificationRead(item["notifyId"], null)
      this.router.navigate(["/personalProfile"], {
        queryParams: { userId: item["notifyEntityId"] },
      });
    } else if (item["notifyType"] === "NETWORK_CONNECT_REQUEST_REJECTED") {
      this.notificationRead(item["notifyId"], null)
      item.notifyData.networkOwnerId = localStorage.getItem('userId')
      this.router.navigate(["networkPage/members"], {
        queryParams: item["notifyData"],
      });
    } else if (item["notifyType"] === "User_itself_remove_from_teams") {
      this.notificationRead(item["notifyId"], null)
      localStorage.setItem('teamId', item["notifyData"]['teamId'])
      item.notifyData.teamsOwnerId = localStorage.getItem('userId')
      this.router.navigate(["teamPage/members"], {
        queryParams: item["notifyData"],
      });
    } else if (item["notifyType"] === "TEAMS_REMOVED") {
      this.notificationRead(item["notifyId"], null)
      this.router.navigate(["teamPage/home"], {
        queryParams: item["notifyData"],
      });
    } else if (item["notifyType"] === "CONNECT_REQUEST_CANCELLED") {
      this.notificationRead(item["notifyId"], null)
      this.router.navigate(["/personalProfile"], {
        queryParams: { userId: item["notifyEntityId"] },
      });
    } else if (item["notifyType"] === "TEAM_CONNECT_REQUEST_ACCEPTED") {
      this.notificationRead(item["notifyId"], null)
      localStorage.setItem('teamId', item["notifyData"]['teamId'])
      item.notifyData.teamsOwnerId = localStorage.getItem('userId')
      this.router.navigate(["teamPage/members"], {
        queryParams: item["notifyData"],
      });
      // } else if (item["notifyType"] === "TEAM_CONNECT_REQUEST_CANCELLED") {
      //   this.notificationRead(item["notifyId"], null)
      //   localStorage.setItem('teamId', item["notifyData"]['teamId'])
      //   item.notifyData.teamsOwnerId = localStorage.getItem('userId')
      //   this.router.navigate(["teamPage/members"], {
      //     queryParams: item["notifyData"],
      //   });
      // }
    } else if (item["notifyType"] === "BUSINESS_PAGE_FOLLOWER_INVITE_SENT") {
      this.notificationRead(item["notifyId"], null)
      item["notifyData"].isSuperAdmin = false;
      localStorage.setItem("businessId", item["notifyEntityId"]);
      this.businessDatailsAPI(item["notifyData"], "post")

    } else if (item["notifyType"] === "LEFT_FROM_MSG_GRP") {
      this.notificationRead(item["notifyId"], null)
      this.router.navigate(["/personalProfile"], {
        queryParams: { userId: item["notifyEntityId"] },
      });
    } else if (item["notifyType"] === "REMOVED_FROM_MSG_GRP") {
      this.notificationRead(item["notifyId"], null)
      this.router.navigate(["/message"], {
        queryParams: { userId: item["notifyData"] },
      });
    } else if (item["notifyType"] === "ADDED_TO_MSG_GRP") {
      this.notificationRead(item["notifyId"], null)
      this.router.navigate(["/message"], {
        queryParams: { userId: item["notifyData"] },
      });
    } else if (item["notifyType"] === "User_itself_remove_from_Network") {
      this.notificationRead(item["notifyId"], null)
      // item.notifyData.routeFrom = "memberLeftNotification"
      item.notifyData.networkOwnerId = localStorage.getItem('userId')
      this.router.navigate(["networkPage/members"], {
        queryParams: item["notifyData"],
      });
    } else if (item["notifyType"] === "BUSINESS_FOLLOWER_ADDED") {

      this.notificationRead(item["notifyId"], null)

      item.notifyData.menu = "follower"
      this.businessDatailsAPI(item["notifyData"], "follower")

    } else if (item["notifyType"] === "COMMUNITY_USER_REQUEST_REJECTED") {
      this.notificationRead(item["notifyId"], null)
      item.notifyData.menu = "home"
      localStorage.setItem("communityId", item["notifyEntityId"]);
      this.router.navigate(["/community"], {
        queryParams: item["notifyData"],
      });
    } else if (item["notifyType"] === "COMMUNITY_MEMBER_REQUEST_ACCEPTED") {
      this.notificationRead(item["notifyId"], null)
      item.notifyData.menu = "home"
      localStorage.setItem("communityId", item["notifyEntityId"]);
      this.router.navigate(["/community"], {
        queryParams: item["notifyData"],
      });
    } else if (item["notifyType"] === "COMMUNITY_MEMBER_REQUEST_REJECTED") {
      this.notificationRead(item["notifyId"], null)
      item.notifyData.menu = "home"
      localStorage.setItem("communityId", item["notifyEntityId"]);
      this.router.navigate(["/community"], {
        queryParams: item["notifyData"],
      });
    } else if (item["notifyType"] === "COMMUNITY_USER_REQUEST_ACCEPTED") {
      this.notificationRead(item["notifyId"], null)
      item.notifyData.menu = "home"
      localStorage.setItem("communityId", item["notifyEntityId"]);
      this.router.navigate(["/community"], {
        queryParams: item["notifyData"],
      });
    } else if (item["notifyType"] === "COMMUNITY_USER_INVITE_REQUEST_REJECTED") {
      this.notificationRead(item["notifyId"], null)
      item.notifyData.menu = "memberspage"
      localStorage.setItem('communityId', item.notifyData.communityId)
      localStorage.setItem('isAdmin', 'false')
      localStorage.setItem('isSuperAdmin', 'true')
      localStorage.setItem('screen', 'community')
      localStorage.setItem('adminviewflag', 'false')
      localStorage.setItem("communityId", item["notifyEntityId"]);
      this.router.navigate(["/community"], {
        queryParams: item["notifyData"],
      });
    } else if (item["notifyType"] === "COMMUNITY_USER_INVITE_REQUEST_ACCEPTED") {
      this.notificationRead(item["notifyId"], null)
      item.notifyData.menu = "memberspage"
      localStorage.setItem('communityId', item.notifyData.communityId)
      localStorage.setItem('isAdmin', 'false')
      localStorage.setItem('isSuperAdmin', 'true')
      localStorage.setItem('screen', 'community')
      localStorage.setItem('adminviewflag', 'false')
      localStorage.setItem("communityId", item["notifyEntityId"]);
      this.router.navigate(["/community"], {
        queryParams: item["notifyData"],
      });
    } else if (item["notifyType"] === "BUSINESS_FOLLOWER_INVITE_REQUEST_REJECTED") {
      this.notificationRead(item["notifyId"], null)
      item.notifyData.menu = "follower"
      this.businessDatailsAPI(item["notifyData"], "follower")

    } else if (item["notifyType"] === "BUSINESS_FOLLOWER_INVITE_REQUEST_ACCEPTED") {
      this.notificationRead(item["notifyId"], null)
      item.notifyData.menu = "follower"
      this.businessDatailsAPI(item["notifyData"], "follower")

    }
    // Contract Agreement Notifications
    if (item["notifyType"] == "CONTRACT_AGREEMENT_DOCUMENT_UPLOADED") {
      this.notificationRead(item["notifyId"], null);
      this.router.navigate(["/contract-center"]);
    }

    if (item["notifyType"] == "CONTRACT_COMPANY_DOC_CHECKLIST_CREATED") {
      this.notificationRead(item["notifyId"], null);
      this.router.navigate(["/contract-center"]);
    }

    if (item["notifyType"] == "CONTRACT_COMPANY_DOC_UPLOADED") {
      this.notificationRead(item["notifyId"], null);
      this.router.navigate(["/contract-center"]);
    }

    if (item["notifyType"] == "CONTRACT_COMPANY_DOC_VERIFIED") {
      this.notificationRead(item["notifyId"], null);
      this.router.navigate(["/contract-center"]);
    }

    if (item["notifyType"] == "CONTRACT_COMPANY_DOC_REJECTED") {
      this.notificationRead(item["notifyId"], null);
      this.router.navigate(["/contract-center"]);
    }

    if (item["notifyType"] == "CONTRACT_AGREEMENT_SIGNING_REQUESTED") {
      this.notificationRead(item["notifyId"], null);
      this.router.navigate(["/contract-center"]);
    }

    if (item["notifyType"] == "CONTRACT_AGREEMENT_SIGNED") {
      this.notificationRead(item["notifyId"], null);
      this.router.navigate(["/contract-center"]);
    }

    if (item["notifyType"] == "CONTRACT_AGREEMENT_ACCEPTED") {
      this.notificationRead(item["notifyId"], null);
      this.router.navigate(["/contract-center"]);
    }

    if (item["notifyType"] == "CONTRACT_AGREEMENT_REJECTED") {
      this.notificationRead(item["notifyId"], null);
      this.router.navigate(["/contract-center"]);
    }

    if (item["notifyType"] == "CONTRACT_WORK_ORDER_INITIATED") {
      this.notificationRead(item["notifyId"], null);
      this.router.navigate(["/contract-center"]);
    }

    if (item["notifyType"] == "CONTRACT_WORK_ORDER_ACCEPTED") {
      this.notificationRead(item["notifyId"], null);
      this.router.navigate(["/contract-center"]);
    }

    if (item["notifyType"] == "CONTRACT_WORK_ORDER_REJECTED") {
      this.notificationRead(item["notifyId"], null);
      this.router.navigate(["/contract-center"]);
    }

    if (item["notifyType"] == "CONTRACT_WORK_ORDER_REVISED") {
      this.notificationRead(item["notifyId"], null);
      this.router.navigate(["/contract-center"]);
    }

    if (item["notifyType"] == "CONTRACT_WORK_ORDER_VOIDED") {
      this.notificationRead(item["notifyId"], null);
      this.router.navigate(["/contract-center"]);
    }

    if (item["notifyType"] == "CONTRACT_INITIATED") {
      this.notificationRead(item["notifyId"], null);
      this.router.navigate(["/contract-center"]);
    }

    if (item["notifyType"] == "CONTRACT_INVOICE_SUBMITTED") {
      this.notificationRead(item["notifyId"], null);
      this.router.navigate(["/contract-center"]);
    }

    if (item["notifyType"] == "CONTRACT_INVOICE_UPDATED") {
      this.notificationRead(item["notifyId"], null);
      this.router.navigate(["/contract-center"]);
    }

    if (item["notifyType"] == "CONTRACT_INVOICE_APPROVED") {
      this.notificationRead(item["notifyId"], null);
      this.router.navigate(["/contract-center"]);
    }

    if (item["notifyType"] == "CONTRACT_INVOICE_REJECTED") {
      this.notificationRead(item["notifyId"], null);
      this.router.navigate(["/contract-center"]);
    }

    if (item["notifyType"] == "CONTRACT_INVOICE_PAID") {
      this.notificationRead(item["notifyId"], null);
      this.router.navigate(["/contract-center"]);
    }

    if (item["notifyType"] == "CONTRACT_PAYMENT_RECEIVED") {
      this.notificationRead(item["notifyId"], null);
      this.router.navigate(["/contract-center"]);
    }

    if (item["notifyType"] == "CONTRACT_INVOICE_VOIDED") {
      this.notificationRead(item["notifyId"], null);
      this.router.navigate(["/contract-center"]);
    }

    const notifyTypes = [
      "STRIPE_PAYMENT_TRANSACTION_FAILURE",
      "STRIPE_INVOICE_SUCCESS",
      "STRIPE_INVOICE_FAILURE",
      "MEMBERSHIP_UPDATED",
      "UPDATED_TO_BUSINESS_PLAN"
    ];

    if (notifyTypes.includes(item["notifyType"])) {
      this.notificationRead(item["notifyId"], null);

      const currentOrg = this.currentOrgProvider.getCurrentOrg;
      const plan = localStorage.getItem('MemberShipType');
      if (plan === "Growth" || plan === "Starter" || plan === "ScaleX") {
        this.router.navigate(["/user-management/billing"]);
      } else {
        const params = {
          userId: localStorage.getItem('userId'),
          businessName: currentOrg?.organisationName || '',
          businessEmail: localStorage.getItem('userName'),
          plan: plan,
          bid: currentOrg?.gigNo || '',
          role: undefined
        };
        this.router.navigate(["/user-management/billing"], { queryParams: params });
      }
    }

  }
  resendCommunityJoinRequest(value, index) {
  }
  markAsRead(value, index) {
    this.funtioncallFlag = true
    this.notificationRead(value["notifyId"], index)
  }
  acceptConnection(value, index) {
    this.funtioncallFlag = true

    var data: any = {};
    data.userId = localStorage.getItem("userId");
    data.connectedUser = value.notifyData.userId;
    data.status = "CONNECTED";
    this.util.startLoader();
    this.api.create("user/connect/accept", data).subscribe((res) => {
      if (res.code == "00000") {
        this.util.stopLoader();
        Swal.fire({
          icon: "success",
          title: "Request accepted successfully",
          // title: "Connection Request",
          showConfirmButton: false,
          timer: 2000,
        }).then(() => {
          this.deleteFromNotification(index)
        })
      } else {
        this.util.stopLoader();
        Swal.fire({
          icon: "info",
          title: "Oops...",
          text: "Connection accept request failed. Please try after a while.",
          showConfirmButton: false,
          timer: 4000,
        });
      }
    });
  }
  getProfileType(item): string {
    // Return the profile type based on the notifyType
    return item.notifyType === 'BUSINESS_PAGE_CONTACT_INVITE_ACCEPTED' ? 'profile' : 'businessPage';
  }

  getTooltipTitle(item): string {
    return item.notifyType === 'BUSINESS_PAGE_CONTACT_INVITE_ACCEPTED'
      ? `${item?.notifyData?.firstName} ${item?.notifyData?.lastName}`
      : item?.notifyData?.businessName;
  }
  handleContactInvite(value, index, action: 'ACCEPT' | 'REJECT') {
    this.funtioncallFlag = true;
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: { confirmButton: 'btn btn-success', cancelButton: 'btn btn-danger' },
      buttonsStyling: false
    })
    const successMessage = action === 'ACCEPT'
      ? "Request accepted successfully"
      : "Contact request rejected";

    const errorMessage = action === 'ACCEPT'
      ? "Contact accept request failed. Please try after a while."
      : "Contact reject request failed. Please try after a while.";

    const data = this.prepareContactInviteData(value, action);

    if (!data) return;

    if (action === 'REJECT') {
      swalWithBootstrapButtons.fire({
        title: `Are you sure you want to reject ${value.notifyData.businessName}?`,
        icon: 'warning',
        showCancelButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.executeContactInvite(data, index, successMessage, errorMessage, value);
        }
      });
    } else {
      this.executeContactInvite(data, index, successMessage, errorMessage, value);
    }
  }

  prepareContactInviteData(value, action: 'ACCEPT' | 'REJECT') {
    if (value.notifyType === 'BUSINESS_PAGE_CONTACT_INVITE') {
      return {
        userId: localStorage.getItem("userId"),
        businessId: value.notifyData.businessId,
        status: action === 'ACCEPT' ? "CONNECTED" : "REJECTED",
      };
    } else {
      // For B2B connections: include peerSubContractAllowed on accept
      // Only the Client (contactType === 'Supplier') sets it; Supplier sends null
      const isAccept = action === 'ACCEPT';
      const isClient = value.notifyData?.contactType === 'Supplier' || value.notifyData?.peerContactType === 'Client';
      return {
        peerBusinessId: value.message,
        businessId: value.notifyData.businessId,
        contactStatus: isAccept ? "CONNECTED" : "REJECTED",
        ...(isAccept ? { peerSubContractAllowed: isClient ? true : null } : {}),
      };
    }
  }

  executeContactInvite(data, index, successMessage, errorMessage, value?: any) {
    this.util.startLoader();

    const isB2B = !data.userId;
    const apiEndpoint = isB2B
      ? "business/updateB2BContact" // For B2B connections
      : "business/updateBusinessUsersContact"; // For BUSINESS_PAGE_CONTACT_INVITE

    const apiMethod = data.userId ? 'updatePut' : 'create';

    this.api[apiMethod](apiEndpoint, data).subscribe(
      (res) => {
        if (res) {
          this.util.stopLoader();
        }
        if (res.code === "00000") {
          Swal.fire({
            icon: "success",
            title: successMessage,
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            this.deleteFromNotification(index);
          });

          // Show B2B document setup modal on B2B accept, then chain assign employees swal for customer
          if (isB2B && data.contactStatus === 'CONNECTED' && value) {
            const myBusinessId = localStorage.getItem('businessId');
            const peerBusinessId = data.peerBusinessId;
            const peerBusinessName = value.notifyData?.businessName;
            const mode = (value.notifyData?.peerContactType === 'Supplier' ||
                          value.notifyData?.contactType === 'Supplier') ? 'customer' : 'supplier';
            this.contractService.getB2BContact(myBusinessId, peerBusinessId).subscribe((b2bRes: any) => {
              const b2bContactId = b2bRes?.data?.b2bContact?.b2bContactId;
              if (b2bContactId) {
                this.modalService.show(B2bDocumentSetupComponent, {
                  initialState: { b2bContactId, myBusinessId, peerBusinessId, peerBusinessName, mode },
                  class: 'modal-lg',
                  backdrop: 'static',
                  keyboard: false
                });
                if (mode === 'customer') {
                  const swalWithBootstrapButtons = Swal.mixin({
                    customClass: { confirmButton: 'btn btn-success' },
                    buttonsStyling: false
                  });
                  const onHiddenSub = this.modalService.onHidden.subscribe(() => {
                    onHiddenSub.unsubscribe();
                    swalWithBootstrapButtons.fire({
                      title: 'Assign Business Employees',
                      text: 'Now that you have connected to the business contact. Please, map your employees that you want to work with this business.',
                      icon: 'question',
                      confirmButtonText: 'OK',
                      allowOutsideClick: false,
                      allowEscapeKey: false,
                      reverseButtons: true,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        this.router.navigate(['/user-management/businessContacts/businessConnectEdit'], {
                          queryParams: { id: myBusinessId, contactBusinessId: peerBusinessId }
                        });
                      }
                    });
                  });
                }
              }
            });
          }
        } else {
          this.showErrorPopup(errorMessage);
        }
      },
      (error) => {
        this.util.stopLoader();
        this.showErrorPopup("Something went wrong. Please try again later.");
      }
    );
  }

  showErrorPopup(message: string) {
    Swal.fire({
      icon: "info",
      title: "Oops...",
      text: message,
      showConfirmButton: false,
      timer: 4000,
    });
  }


  closeModal(data?) {
    this.showModal = false;
    this.modalService.hide(this.modalService.getModalsCount());

  }
  showModal: boolean = false;
  selectedItem: string = 'businessContacts';
  selectedBusinessEmail: string;
  businessDetails: any
  ownerbusinessId: any
  myResolvedBusinessId: string = '';
  async opencontactmodal(item, index) {

    if (item['notifyType'] === 'BUSINESS_COLLABRATION_INVITE') {
      this.util.startLoader();

      const plan = await this.customerService.getBusinessPLanBenefits(item.message, "B2B_CONTACTS");

      if (plan.available > 0) {
        this.selectedBusinessEmail = item.notifyData.businessEmail;
        this.ownerbusinessId = item.message
        this.getbusinessId(item)
        this.myResolvedBusinessId = localStorage.getItem('businessId') || '';
        this.showModal = true;
      }
      else {
        this.pricePlanService.expiredPopup(
          "B2B_CONTACTS",
          "PAY",
          null,
          null,
          null,
          null,
          plan.available,
          plan.actual,
          plan.utilized,
          plan.promotional
        );
      }

      this.util.stopLoader();

    } else {
      const action = 'ACCEPT';
      this.handleContactInvite(item, index, action);
    }

  }
  getbusinessId(item) {
    const userId = localStorage.getItem('userId');
    this.util.startLoader();
    this.Gigsumoservice.getBusinessId(userId).subscribe(response => {
      this.util.stopLoader();
      this.businessDetails = {
        ...this.businessDetails, // Keep existing details
        id: response.data.businessData.businessId,
        businessEmail: response.data.businessData.businessEmail,
        businessName: response.data.businessData.businessName,
        bid: response.data.businessData.platformBusinesId,
        plan: response.data.businessData.subscriptionType
      };
      this.businessDetails = this.getNetworkParams(this.businessDetails, item);
    });
  }
  getNetworkParams(businessDetails, item) {
    return { ...businessDetails, contactBusinessId: item.notifyData.businessId };
  }

  rejectConnection(value, index) {
    this.funtioncallFlag = true

    var data: any = {};
    data.userId = localStorage.getItem("userId");
    data.connectedUser = value.notifyData.userId;
    data.status = "REJECTED";
    this.util.startLoader();
    this.api.create("user/connect/accept", data).subscribe((res) => {
      if (res.code == "00000") {
        this.util.stopLoader();
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Connection request rejected",
          showConfirmButton: false,
          timer: 2000,
        }).then(() => {
          this.deleteFromNotification(index)
        })
      } else {
        this.util.stopLoader();
        Swal.fire({
          position: "center",
          icon: "info",
          title: "Oops...",
          text: "Something went wrong. Please try after some time.",
          showConfirmButton: false,
          timer: 2000,
        })
      }
    });
  }

  acceptCommunityInvitation(value, index) {
    this.funtioncallFlag = true
    let data: any = {};
    data.entityId = value.notifyData.communityId
    data.userId = localStorage.getItem('userId');
    this.util.startLoader()
    this.api.create("community/accept/invite", data).subscribe(res => {
      this.util.stopLoader()
      if (res.code == "00000") {

        Swal.fire({
          icon: "success",
          title: "You have successfully joined Community",
          showConfirmButton: false,
          timer: 2000,
        }).then(() => {
          this.deleteFromNotification(index)
        })
      } else {
        this.util.stopLoader()

        Swal.fire({
          position: "center",
          icon: "info",
          title: "Oops...",
          text: "Please try again some time later.",
          showConfirmButton: false,
          timer: 3000,
        });
      }
    });
  }
  rejectCommunityInvitation(value, index) {
    this.funtioncallFlag = true

    let datas: any = {};
    datas.entityId = value.notifyData.communityId
    datas.userId = localStorage.getItem('userId');
    this.util.startLoader()
    this.api.create("community/reject/invite", datas).subscribe(res => {
      this.util.stopLoader()
      if (res.code == "00000") {

        Swal.fire({
          position: "center",
          icon: "success",
          title: "Invitation rejected",
          showConfirmButton: false,
          timer: 2500,
        }).then(() => {
          this.deleteFromNotification(index)
        })
      } else {
        this.util.stopLoader()

        Swal.fire({
          position: "center",
          icon: "info",
          title: "Oops...",
          text: "Please try again some time later.",
          showConfirmButton: false,
          timer: 3000,
        });
      }
    });
  }
  addOrRejectMemberToCommunity(values, status, index) {
    this.funtioncallFlag = true

    let data: any = {}
    data.communityId = values.notifyData.communityId;
    data.userId = values.notifyData.userId
    data.communityJoinStatus = status
    this.util.startLoader()
    this.api.create('community/join/acceptrequest', data).subscribe(res => {
      this.util.stopLoader()

      if (res.code == '00000') {

        if (status == 'ACCEPT') {
          Swal.fire({
            icon: "success",
            title: "Member successfully added to Community",

            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            this.deleteFromNotification(index)
          })
        } else if (status == 'REJECT') {
          Swal.fire({
            icon: "success",
            title: "Request rejected",

            showConfirmButton: false,
            timer: 2500,
          }).then(() => {
            this.deleteFromNotification(index)
          })
        }
      } else {
        Swal.fire({
          icon: "info",
          title: "Oops...",
          text: "Something went wrong. Please, try again later.",
          showConfirmButton: false,
          timer: 4000,
        })
      }
      let val = localStorage.getItem('reqcount');
      if (!isNaN(Number(val))) {
        let numberValue = Number(val);
        if (numberValue > 0) {
          localStorage.setItem('reqcount', (numberValue - 1).toString());
        }
      }
    });
  }
  rejectNetworkMemberInvitation(value, index) {
    this.funtioncallFlag = true

    var usId = localStorage.getItem("userId");
    var obj: any = {};
    obj.memberUserId = usId;
    obj.networkId = value.notifyData.networkId;
    obj.status = "REJECT";
    this.api.create("network/reject/invite", obj).subscribe((res) => {
      if (res.code == "00000") {

        Swal.fire({
          position: "center",
          icon: "success",
          title: "Network invitation rejected",
          showConfirmButton: false,
          timer: 2000,
        }).then(() => {
          this.deleteFromNotification(index)
          this.netCls.ngOnInit();
        })
      } else if (res.code == "99999") {
        Swal.fire({
          position: "center",
          icon: "info",
          title: "Oops...",
          text: "Something went wrong. Please try again later.",
          showConfirmButton: false,
          timer: 3000,
        })
      }
    });
  }
  acceptNetworkMemberInvitation(value, index) {
    this.funtioncallFlag = true

    var usId = localStorage.getItem("userId");
    var obj: any = {};
    obj.memberUserId = usId;
    obj.networkId = value.notifyData.networkId;
    obj.status = "ACCEPT";
    this.util.startLoader()
    this.api.create("network/accept/member", obj).subscribe((res) => {
      if (res.code == "00000") {
        this.util.stopLoader()

        Swal.fire({
          position: "center",
          icon: "success",
          title: "You have been successfully added to Network",
          showConfirmButton: false,
          timer: 2000,
        }).then(() => {
          this.deleteFromNotification(index)
          this.netCls.ngOnInit();
        })
      } else {
        this.util.stopLoader()

        Swal.fire({
          position: "center",
          icon: "info",
          title: "Oops...",
          text: "Please try again some time later.",
          showConfirmButton: false,
          timer: 3000,
        });
      }
    });
  }
  rejectTeamInvitation(dataInput, index) {
    this.funtioncallFlag = true
    var usId = localStorage.getItem("userId");
    var obj: any = {};
    obj.memberUserId = usId;
    obj.teamId = dataInput.notifyData.teamId;
    obj.status = "REJECT";
    this.util.startLoader();
    this.api.create("teams/accept", obj).subscribe((res) => {
      this.util.stopLoader();
      if (res.code == "00000") {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Invitation rejected",
          showConfirmButton: false,
          timer: 2000,
        }).then(() => {
          this.deleteFromNotification(index)
          this.tmCls.getallteams("PENDING");
        })
      } else {
        this.util.stopLoader()

        Swal.fire({
          position: "center",
          icon: "info",
          title: "Oops...",
          text: "Please try again some time later.",
          showConfirmButton: false,
          timer: 3000,
        });
      }
    });
  }
  inviteAgainToNetwork(item) {
  }
  acceptTeamInvitation(dataInput, index) {
    this.funtioncallFlag = true
    var usId = localStorage.getItem("userId");
    var obj: any = {};
    obj.memberUserId = usId;
    obj.teamId = dataInput.notifyData.teamId;
    obj.status = "ACCEPT";
    this.util.startLoader();
    this.api.create("teams/accept", obj).subscribe((res) => {
      this.util.stopLoader();
      if (res.code == "00000") {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "You've been successfully added to Workspace",
          showConfirmButton: false,
          timer: 2000,
        }).then(() => {
          this.deleteFromNotification(index)
          this.tmCls.getallteams("PENDING");
        })
      } else {
        this.util.stopLoader()

        Swal.fire({
          position: "center",
          icon: "info",
          title: "Oops...",
          text: "Please try again some time later.",
          showConfirmButton: false,
          timer: 3000,
        });
      }
    });
  }
  count1: number = 0
  notificationZeroFlag: boolean = false

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    const month = date.getUTCMonth() + 1; // Months are zero-based
    const day = date.getUTCDate();
    const year = date.getUTCFullYear();

    // Pad single-digit month and day with leading zero
    const formattedMonth = month < 10 ? `0${month}` : month;
    const formattedDay = day < 10 ? `0${day}` : day;

    return `${formattedMonth}/${formattedDay}/${year}`;
  }


  getNotification(val: any): any {

    if (val) {
      this.count = this.count + 1
      if (this.count == 1) {
        this.notifications = []
      }
      val.forEach((ele: any) => {
        prepareNotificationForDisplay(ele);
        this.notifications.push(ele)
        let temp = this.duplicate(this.notifications);
        this.notifications = temp;
      })
      this.commonVariables.notifications = this.notifications
      this.searchData.setCommonVariables(this.commonVariables)
    }

  }
  duplicate(data) {
    var temp = [];
    var arr = data.filter(function (el) {

      if (temp.indexOf(el.notifyId) == -1) {
        temp.push(el.notifyId);
        return true;
      }
      return false;
    });
    return arr;
  }


  businessDatailsAPI(data, path) {
    const datas: any = {};
    datas.businessId = data.businessId;
    datas.userId = localStorage.getItem("userId");
    this.util.startLoader();
    this.api.create("business/check/admin", datas).subscribe((res) => {
      this.util.stopLoader();
      // res.menu=path;
      const mergedParams = { ...data, ...res };
      const urlPath = path ? `/business/${path}` : '/business/';
      // this.router.navigateByUrl(urlPath);
      this.router.navigate([urlPath], {
        queryParams: mergedParams,
      });
    });
  }

  JoinCommunity(id) {
    let data: any = {}
    data.communityId = id;
    data.userId = localStorage.getItem('userId')
    this.api.create('community/home', data).subscribe(res => {
      res.data.communityhome.aboutCommunity = "";
      this.router.navigate(["/community"], {
        queryParams: res.data.communityhome,
      });

    });
  }
  formatCandidateIds(message: string): string {
    if (!message) return '';
    return message
      .split(',')
      .map(id => id.trim())
      .join(', ');
  }
  getCandidateCount(message: string): number {
    return message ? message.split(',').filter(id => id.trim()).length : 0;
  }
  
  formatCandidateId(message: string): string {
    return message ? message.split(',').map(id => id.trim()).join(', ') : '';
  }

  addSpace(item) {
    return item.replace(/,/g, ", ");
  }

  scalexPayment(item:any,i:any){
    const url = item.message;
    console.log('url',url);
    if(url){
      window.location.href = item.message;      
    }

  }
 
}



